/**
 * プランの識別子と表示名 — フロントエンドの SSOT
 *
 * ここで扱うのは「'premium' という識別子」と「画面に出す呼び名」だけ。
 * 上限値そのもの（何件まで・何回まで）は backend/src/common/usage_limits.py が SSOT で、
 * 掲載用の一覧は constants/planFeatures.ts にある。
 *
 * 呼び名は料金ページ（/pricing）の表記に合わせる。同じプランが画面によって
 * 「Basic」「Basicプラン」「ベーシックプラン」と揺れていたため統一した。
 */

export const PLAN_TYPE = {
  FREE: 'free',
  BASIC: 'basic',
  PREMIUM: 'premium',
} as const;

export type PlanType = (typeof PLAN_TYPE)[keyof typeof PLAN_TYPE];

/** 画面に出すプラン名 */
export const PLAN_NAME: Record<PlanType, string> = {
  [PLAN_TYPE.FREE]: '無料プラン',
  [PLAN_TYPE.BASIC]: 'ベーシックプラン',
  [PLAN_TYPE.PREMIUM]: 'プレミアムプラン',
};

/** 比較表の見出しなど、幅が限られる場所で使う短い名前 */
export const PLAN_SHORT_NAME: Record<PlanType, string> = {
  [PLAN_TYPE.FREE]: '無料',
  [PLAN_TYPE.BASIC]: 'ベーシック',
  [PLAN_TYPE.PREMIUM]: 'プレミアム',
};

/** 課金が発生するプランかどうか */
export const isPaidPlan = (planType: PlanType): boolean => planType !== PLAN_TYPE.FREE;

/** ひとつ上のプラン。プレミアムなら null */
export const nextPlanOf = (planType: PlanType): PlanType | null => {
  if (planType === PLAN_TYPE.FREE) return PLAN_TYPE.BASIC;
  if (planType === PLAN_TYPE.BASIC) return PLAN_TYPE.PREMIUM;
  return null;
};
